/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type EntityPagesArticleModuleContentArticleEnableMutationVariables =
  Types.Exact<{
    input?: Types.InputMaybe<Types.ContentEnableArticleInput>;
  }>;

export type EntityPagesArticleModuleContentArticleEnableMutation = {
  __typename?: 'Mutation';
  contentEnableArticle?: {
    __typename?: 'ContentArticleMutationResult';
    success?:
      | { __typename?: 'ContentArticle'; status: Types.ContentArticleStatus }
      | {
          __typename?: 'ContentKlartextKlarticle';
          status: Types.ContentArticleStatus;
        }
      | null;
    error?: {
      __typename?: 'ContentError';
      message?: string | null;
      description?: string | null;
      errors?: Array<string> | null;
    } | null;
  } | null;
};

export const EntityPagesArticleModuleContentArticleEnableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {
        kind: 'Name',
        value: 'entityPagesArticleModuleContentArticleEnable',
      },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ContentEnableArticleInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEnableArticle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'success' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'error' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errors' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityPagesArticleModuleContentArticleEnableMutation,
  EntityPagesArticleModuleContentArticleEnableMutationVariables
>;
